/* unplugin-vue-components disabled */import script from "./Entry.vue?vue&type=script&lang=ts&setup=true"
export * from "./Entry.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__